import { groupBy } from 'lodash'
import * as Effects from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import {
  acceptTemplates,
  rejectTemplates,
} from '../../actions/templates/loadTemplates'
import { fetchTemplates, ITemplate } from '../../models/Templates'
import { TemplatesActions } from '../../reducers/templates/actionNames'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'

export function* loadTemplates() {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchTemplates)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, fetchTemplates),
      ),
    ])

    const templates: ITemplate[] = yield Effects.call(service)
    yield Effects.put(
      acceptTemplates(templates, groupBy(templates, 'language')),
    )
    return templates
  } catch (e) {
    console.log(e)
    yield Effects.put(rejectTemplates(e.message))
  }
}

export default function*() {
  yield Effects.takeEvery(TemplatesActions.RequestForTemplates, loadTemplates)
}
